import { formatIDR } from "@/lib/constants";

/**
 * LedgerPreviewPanel — 149-bs. Extracted preview calculation panel from
 * IncomeLedgerDialog. Pure display: menampilkan preview Invoice/Tax/Retention/Net
 * (mode regular) atau Claim/Tax/Net (mode retention claim).
 */
export default function LedgerPreviewPanel({ formPreview, isClaim, formAmount, pphPct, retPct }) {
  if (!formPreview && !isClaim) return null;
  return (
    <div className="md:col-span-6 border border-slate-200 bg-slate-50 divide-y divide-slate-200" data-testid="income-preview">
      <div className="px-3 py-2 flex items-center justify-between text-xs">
        <span className="overline text-slate-600">{isClaim ? "Preview Retention Claim" : "Preview Calculation"}</span>
        {!isClaim && formPreview?.pct_of_contract != null && (
          <span className="text-[10px] text-slate-500 tabular-nums">= {formPreview.pct_of_contract.toFixed(2)}% of contract</span>
        )}
      </div>
      {isClaim ? (
        <ClaimPreview formAmount={formAmount} pphPct={pphPct} />
      ) : (
        <RegularPreview formPreview={formPreview} pphPct={pphPct} retPct={retPct} />
      )}
    </div>
  );
}

function ClaimPreview({ formAmount, pphPct }) {
  const amt = parseFloat(formAmount) || 0;
  const pphAmt = Math.round(amt * pphPct / 100 * 100) / 100;
  const netAmt = amt - pphAmt;
  return (
    <div className="grid grid-cols-3">
      <div className="px-3 py-2 border-r border-slate-200 bg-amber-50/40">
        <div className="overline text-amber-700 text-[9px]">Claim Amount</div>
        <div className="tabular-nums font-semibold text-amber-800" data-testid="claim-preview-amount">{formatIDR(amt)}</div>
      </div>
      <div className="px-3 py-2 border-r border-slate-200 bg-sky-50/40">
        <div className="overline text-sky-700 text-[9px]">Tax ({pphPct}%)</div>
        <div className="tabular-nums font-semibold text-sky-800" data-testid="claim-preview-pph">− {formatIDR(pphAmt)}</div>
      </div>
      <div className="px-3 py-2 bg-emerald-50/40">
        <div className="overline text-emerald-700 text-[9px]">Received (Net)</div>
        <div className="tabular-nums font-semibold text-emerald-800" data-testid="claim-preview-net">{formatIDR(netAmt)}</div>
      </div>
    </div>
  );
}

function RegularPreview({ formPreview, pphPct, retPct }) {
  return (
    <div className="grid grid-cols-4">
      <div className="px-3 py-2 border-r border-slate-200">
        <div className="overline text-slate-500 text-[9px]">Invoice</div>
        <div className="tabular-nums font-semibold text-[#0B1D3A]" data-testid="income-preview-billed">{formatIDR(formPreview.billed)}</div>
      </div>
      <div className="px-3 py-2 border-r border-slate-200 bg-sky-50/40">
        <div className="overline text-sky-700 text-[9px]">Tax ({pphPct}%)</div>
        <div className="tabular-nums font-semibold text-sky-800" data-testid="income-preview-pph">− {formatIDR(formPreview.pph)}</div>
      </div>
      <div className="px-3 py-2 border-r border-slate-200 bg-amber-50/40">
        <div className="overline text-amber-700 text-[9px]">Retention ({retPct}%)</div>
        <div className="tabular-nums font-semibold text-amber-800" data-testid="income-preview-retention">− {formatIDR(formPreview.retention)}</div>
      </div>
      <div className="px-3 py-2 bg-emerald-50/40">
        <div className="overline text-emerald-700 text-[9px]">Received (Net)</div>
        <div className="tabular-nums font-semibold text-emerald-800" data-testid="income-preview-net">{formatIDR(formPreview.net)}</div>
      </div>
    </div>
  );
}
